import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import productData from "../Datas/productData";
import "../css/main.scss";

function formatJustLandedPrice(price) {
  const num = Number.parseFloat(String(price), 10);
  if (Number.isNaN(num)) return price;
  return `£${Math.round(num)}`;
}

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const justLanded = productData.slice(0, 5);

  const featuredShoes = productData.slice(3, 7);

  return (
    <div className="main">
      <Header />

      <main>
        <section className="main-hero" aria-label="Footwear collection">
          <div className="main-hero__inner">
            <div className="main-hero__content">
              <h1 className="main-hero__title">
                <span className="main-hero__title-line">Step Into</span>
                <span className="main-hero__title-line">Every Day</span>
              </h1>
              <p className="main-hero__sub">
                Discover versatile shoes designed for comfort, movement, and
                everyday style.
              </p>
              <div className="main-hero__ctas">
                <Link className="main-hero__btn" to="/shop" onClick={toTop}>
                  Shop sneakers
                </Link>
                <Link className="main-hero__btn" to="/shop" onClick={toTop}>
                  Shop all shoes
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section
          className="main-just-landed"
          aria-labelledby="main-just-landed-heading"
        >
          <h2 id="main-just-landed-heading" className="main-just-landed__title">
            New Footwear
          </h2>
          <div className="main-just-landed__row">
            {justLanded.map((product) => (
              <article
                key={product.id}
                className={
                  product.justLandedFeatured
                    ? "main-just-landed__card main-just-landed__card--featured"
                    : "main-just-landed__card"
                }
              >
                <Link
                  className="main-just-landed__link"
                  to={`/shopDetails/${product.id}`}
                  onClick={toTop}
                >
                  <div className="main-just-landed__img-wrap">
                    <img
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                    />
                  </div>
                  <h3 className="main-just-landed__name">{product.name}</h3>
                  <p className="main-just-landed__price">
                    {formatJustLandedPrice(product.price)}
                  </p>
                </Link>
              </article>
            ))}
          </div>
        </section>

        <section
          className="main-split-banner"
          aria-label="Everyday sneaker promotion"
        >
          <div className="main-split-banner__half main-split-banner__half--left">
            <img
              className="main-split-banner__video"
              src="/img/editorial-shoes/home-casual-steps.png"
              alt="Two friends wearing casual sneakers on city steps"
            />
          </div>
          <div className="main-split-banner__half main-split-banner__half--right">
            <div className="main-split-banner__overlay">
              <h2 className="main-split-banner__headline">
                <span className="main-split-banner__headline-line">
                  Built for
                </span>
                <span className="main-split-banner__headline-line">
                  Every Step
                </span>
              </h2>
              <p className="main-split-banner__sub">
                Cushioned sneakers and easy silhouettes for days on the move.
              </p>
              <Link
                className="main-split-banner__btn"
                to="/shop"
                onClick={toTop}
              >
                Shop sneakers
              </Link>
            </div>
          </div>
        </section>

        <section
          className="main-spring-dresses"
          aria-labelledby="main-spring-dresses-heading"
        >
          <div className="main-spring-dresses__head">
            <h2
              id="main-spring-dresses-heading"
              className="main-spring-dresses__title"
            >
              Featured Shoes
            </h2>
            <Link
              className="main-spring-dresses__view-all"
              to="/shop"
              onClick={toTop}
            >
              View all
            </Link>
          </div>
          <div className="main-spring-dresses__grid">
            {featuredShoes.map((product) => (
              <article key={product.id} className="main-spring-dresses__card">
                <Link
                  className="main-spring-dresses__link"
                  to={`/shopDetails/${product.id}`}
                  onClick={toTop}
                >
                  <div className="main-spring-dresses__img-wrap">
                    {product.springBreakQuickView ? (
                      <span
                        className="main-spring-dresses__quick"
                        aria-hidden="true"
                      >
                        <svg
                          className="main-spring-dresses__quick-icon"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.6"
                        >
                          <circle cx="11" cy="11" r="7" />
                          <path d="M20 20l-4-4" strokeLinecap="round" />
                        </svg>
                      </span>
                    ) : null}
                    <img
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                    />
                  </div>
                  <h3 className="main-spring-dresses__name">{product.name}</h3>
                  <p className="main-spring-dresses__price">
                    {formatJustLandedPrice(product.price)}
                  </p>
                </Link>
              </article>
            ))}
          </div>
        </section>

        {/* 3 */}

        <section
          className="main-split-banner"
          aria-label="Boot and dress shoe promotion"
        >
          <div className="main-split-banner__half main-split-banner__half--right main-split-banner__half--right2">
            <div className="main-split-banner__overlay">
              <h2 className="main-split-banner__headline">
                <span className="main-split-banner__headline-line">
                  Polished for
                </span>
                <span className="main-split-banner__headline-line">
                  City Days
                </span>
              </h2>
              <p className="main-split-banner__sub">
                Refined loafers, Derby shoes, and boots with all-day support.
              </p>
              <Link
                className="main-split-banner__btn"
                to="/shop"
                onClick={toTop}
              >
                Shop shoes &amp; boots
              </Link>
            </div>
          </div>
          <div className="main-split-banner__half main-split-banner__half--left">
            <img
              className="main-split-banner__video"
              src="/img/editorial-shoes/home-lacing-boots.png"
              alt="A city walker lacing cocoa ankle boots"
            />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
